// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3TrSF","title":"ClientInsurance_title__1z4KP","itemText":"ClientInsurance_itemText__1cgAV"};